import type { TrivoreOfficer } from "../types";

export interface OfficerNaytto {
  uid: string;
  nimi: string;
  sahkoposti: string;
}

export function officerNaytto(o: TrivoreOfficer): OfficerNaytto {
  return {
    uid: o.id,
    nimi: `${o.name.givenName ?? ""} ${o.name.familyName ?? ""}`.trim(),
    sahkoposti: o.email ?? "",
  };
}
